module.exports = __webpack_public_path__ + "img/dagang_title.60e5b63e.png";